"use strict";

const { produceXMLSerialization } = require("./serialization");

exports.implementation = class XMLSerializerImpl {
  serializeToString(root) {
    return produceXMLSerialization(root, false);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/w3c-xmlserializer/lib/XMLSerializer-impl.js
// module id = nyJV
// module chunks = 0